import PresidentServices from '../../services/workTeam/President';

export const state = {
    presidents: [],
    president: {},
}

export const mutations = {
    setPresident(state, president) {
        state.president = president
    },
    setPresidents(state, presidents) {
        state.presidents = presidents
    }
}

export const getters = {
    getPresident(state) {
        return state.president;
    },
    getPresidents(state) {
        return state.presidents;
    },
}

export const actions = {
    get({commit}, id){
        return PresidentServices.get(id)
        .then((response)=>{
            commit('setPresident', response.data.data)
            return response
        })
    },
    getAll({commit}, data = {}){
        return PresidentServices.getAll(data)
        .then((response)=>{
            commit('setPresidents', response.data.data)
            return response
        })
    },
    delete({state, commit}, id){
        return PresidentServices.delete(id)
        .then((response)=>{
            commit('setPresidents', state.presidents.filter((x)=>x.id != id))
            return response
        })
    },
}